import { render, staticRenderFns } from "./StorefrontCollectionForm.vue?vue&type=template&id=bdda9280&scoped=true&"
import script from "./StorefrontCollectionForm.vue?vue&type=script&lang=js&"
export * from "./StorefrontCollectionForm.vue?vue&type=script&lang=js&"
import style0 from "./StorefrontCollectionForm.vue?vue&type=style&index=0&id=bdda9280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdda9280",
  null
  
)

export default component.exports